import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

export const SSHKeysResourceLoadable = Loadable<any, never>({
  loading: LoadingPage,
  loader: () => import('./ssh-keys'),
});
